const darkPalette = {
    text: {
      primary: '#FFFFFF',
      secondary: '#636669',
      disabled: '#636669',
    },
    primary: {
      dark: '#0cb259',
      main: '#12FF80',
      light: '#A1A3A7',
    },
    secondary: {
      dark: '#636669',
      main: '#FFFFFF',
      light: '#B0FFC9',
      background: '#1B2A22',
    },
    border: {
      main: '#636669',
      light: '#303033',
      background: '#121312',
    },
    error: {
      dark: '#AC2C3B',
      main: '#FF5F72',
      light: '#FFB4BD',
      background: '#2F2527',
    },
    success: {
      dark: '#388E3C',
      main: '#00B460',
      light: '#81C784',
      background: '#1F2920',
    },
    info: {
      dark: '#52BFDC',
      main: '#5FDDFF',
      light: '#B7F0FF',
      background: '#19252C',
    },
    warning: {
      dark: '#C04C32',
      main: '#FF8061',
      light: '#FFBC9F',
      background: '#2F2318',
    },
    background: {
      default: '#121312',
      main: '#121312',
      paper: '#1C1C1C',
      light: '#1B2A22',
      lightGrey: '#303033',
    },
    backdrop: {
      main: '#636669',
    },
    logo: {
      main: '#FFFFFF',
      background: '#303033',
    },
    static: {
      main: '#121312',
      light: '#636669',
    },
  }
  
  export default darkPalette